import React from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import * as serviceWorker from './serviceWorker'
import { RouterProvider } from 'react-router/dom'
import './i18n'
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import { router } from './router'
import { LoginProvider } from 'hooks/login'
import { UserProvider } from 'hooks/user'
import { HEALTH_REDIRECT_URI } from 'constants/index'
import { SalesPoolProvider } from 'Components/General/SalesPoolProvider/SalesPoolProvider'
import CaleoThemeProvider from './ThemeProvider'
import { SearchProvider } from 'Components/General/SearchProvider/SearchProvider'
import { MenuProvider } from 'Components/General/NavigationMenu/menu'
import { PrintPreviewProvider } from 'pages/CVPrint/PrintPreviewProvider'
import { ProposalSearchProvider } from 'Components/General/ProposalSearchProvider/ProposalSearchProvider'
import { NotificationPopupProvider } from 'Components/reusable/Notification'
import { MsalProvider } from '@azure/msal-react'
import { msalInstance } from 'msal'
import { reloadOnceForChunkError } from 'Routes/ErrorFallback'

export const instance = msalInstance

// A tab opened before a deploy asks for chunks that no longer exist: reload to get the new build.
// Covers the public routes too, which have no error boundary.
window.addEventListener('vite:preloadError', event => {
  if (reloadOnceForChunkError()) event.preventDefault()
})

const container = document.getElementById('root')
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!)
root.render(
  <React.StrictMode>
    {window.location.pathname !== HEALTH_REDIRECT_URI ? (
      <>
        <a className="skip-link" href="#main-content">
          Skip to main content
        </a>
        <main id="main-content" tabIndex={-1}>
          <MsalProvider instance={msalInstance}>
            <CaleoThemeProvider>
              <LoginProvider>
                <UserProvider>
                  <NotificationPopupProvider>
                    <SalesPoolProvider>
                      <SearchProvider>
                        <ProposalSearchProvider>
                          <PrintPreviewProvider>
                            <MenuProvider>
                              <RouterProvider router={router} />
                            </MenuProvider>
                          </PrintPreviewProvider>
                        </ProposalSearchProvider>
                      </SearchProvider>
                    </SalesPoolProvider>
                  </NotificationPopupProvider>
                </UserProvider>
              </LoginProvider>
            </CaleoThemeProvider>
          </MsalProvider>
        </main>
      </>
    ) : null}
  </React.StrictMode>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
